// extracted by mini-css-extract-plugin
module.exports = {"container":"Event_container__S10pY"};